/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, index: NonNullable<unknown> }} Ai_Event_Group_NameInputs */



/**
* | output |
* | --- |
* | "AI {type} 0{index}" |
*
* @param {Ai_Event_Group_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_event_group_name = /** @type {((inputs: Ai_Event_Group_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Event_Group_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई __पीएच_0__ 0__पीएच_1__")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`IA ${i?.type} 0${i?.index}`)
	return /** @type {LocalizedString} */ (`AI ${i?.type} 0${i?.index}`)
});